module.exports = __webpack_public_path__ + "img/left_training_1.48077b4e.svg";